import React, { useMemo } from "react";
import GridLayout, { WidthProvider } from "react-grid-layout";
import { GridDimensions } from "lib";
import {
    CONTAINER_PADDING,
    ITEM_MARGIN,
    ITEM_MARGIN_VERTICAL,
} from "../layout-grid-section";

// To fix problem with @types/react-grid-layout
const ReactGridLayout = WidthProvider(GridLayout) as any;

export const VisualGrid = React.memo(
    ({
        columns,
        rows,
        height,
        width,
    }: {
        columns: GridDimensions["columns"];
        rows: GridDimensions["rows"];
        height: number;
        width: number;
    }) => {
        const visualGridItems = useMemo(
            () =>
                [...Array(rows * columns)].fill(undefined).map((_, index) => (
                    <div
                        key={index.toString()}
                        data-grid={{
                            i: index.toString(),
                            x: index % columns,
                            y: Math.floor(index / columns),
                            w: 1,
                            h: 1,
                        }}
                        style={cssStyles.gridItem}
                    >
                        <div />
                    </div>
                )),
            [columns, rows]
        );

        return (
            <ReactGridLayout
                className="visual_grid"
                containerPadding={CONTAINER_PADDING}
                margin={ITEM_MARGIN}
                cols={columns}
                rowHeight={height / rows - ITEM_MARGIN_VERTICAL * 2}
                width={width}
                autoSize={false}
                isDraggable={false}
                isResizable={false}
                style={cssStyles.gridLayout}
            >
                {visualGridItems}
            </ReactGridLayout>
        );
    }
);

// Styles used with the React / HTML elements
const cssStyles: { [key: string]: React.CSSProperties } = {
    gridItem: {
        borderColor: "lightgray",
        borderStyle: "dashed",
        borderWidth: 1,
    },
    gridLayout: {
        position: "absolute",
        height: "100%",
        width: "100%",
    },
};
